module.exports = __webpack_public_path__ + "39486d376167935a50e0565471dea129.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-16.png
// module id = 2280
// module chunks = 0